import { render, staticRenderFns } from "./productAppointment.vue?vue&type=template&id=5ef3bfce&scoped=true"
import script from "./productAppointment.vue?vue&type=script&lang=js"
export * from "./productAppointment.vue?vue&type=script&lang=js"
import style0 from "./productAppointment.vue?vue&type=style&index=0&id=5ef3bfce&prod&lang=scss&scoped=true"
import style1 from "./productAppointment.vue?vue&type=style&index=1&id=5ef3bfce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef3bfce",
  null
  
)

export default component.exports